import { useCallback, useState } from 'react';
import { ConfirmDialog, type ConfirmOptions } from './ConfirmDialog';

interface PendingConfirm {
  options: ConfirmOptions;
  resolve: (value: boolean) => void;
}

/**
 * 页内确认对话框 hook：const { confirm, dialog } = useConfirm();
 * 调用 `if (!(await confirm({ title, ... }))) return;` 后把 `{dialog}` 渲染进组件 JSX。
 */
export function useConfirm() {
  const [request, setRequest] = useState<PendingConfirm | null>(null);

  const confirm = useCallback(
    (options: ConfirmOptions) =>
      new Promise<boolean>(resolve => {
        setRequest({ options, resolve });
      }),
    [],
  );

  const finish = useCallback(
    (result: boolean) => {
      request?.resolve(result);
      setRequest(null);
    },
    [request],
  );

  const dialog = request ? (
    <ConfirmDialog {...request.options} onConfirm={() => finish(true)} onCancel={() => finish(false)} />
  ) : null;

  return { confirm, dialog };
}
